import React, { useCallback, memo } from 'react';
import { useQueryLoader } from 'react-relay';
import { useGlobalScopeEnrolmentEnable } from '@atlassian/jira-issue-navigator-changeboarding/src/controllers/global-scope-enrolment-flow/index.tsx';
import { sidebarFiltersGlobalResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/filters/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import MENU_QUERY, {
	type menuNavigationAppsSidebarFiltersGlobalScopeQuery,
} from '@atlassian/jira-relay/src/__generated__/menuNavigationAppsSidebarFiltersGlobalScopeQuery.graphql';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { Menu } from './menu/index.tsx';

const SidebarFiltersGlobalContent = memo(() => {
	const { queryReference: resourceQueryRef } = useRelayResource(sidebarFiltersGlobalResource);
	const [queryReference, loadQuery] =
		useQueryLoader<menuNavigationAppsSidebarFiltersGlobalScopeQuery>(MENU_QUERY, resourceQueryRef);

	const cloudId = useCloudId();
	const onFavouritesChanged = useCallback(() => {
		loadQuery(
			{
				cloudId,
			},
			{ fetchPolicy: 'store-and-network' },
		);
	}, [cloudId, loadQuery]);

	return (
		// TODO: Change to React Suspense when it's supported in SSR.
		<Placeholder name="filters-global" fallback={<Skeleton isFull />}>
			<SidebarRenderStart />
			{queryReference ? (
				<>
					<Menu queryReference={queryReference} onFavouritesChanged={onFavouritesChanged} />
					{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.FILTERS_GLOBAL} />}
				</>
			) : (
				<Skeleton isFull />
			)}
		</Placeholder>
	);
});

export const SidebarFiltersGlobal = () => {
	const [isNinGlobalScopeEnrolmentEnabled] = useGlobalScopeEnrolmentEnable();

	if (isNinGlobalScopeEnrolmentEnabled) {
		return <SidebarFiltersGlobalContent />;
	}

	return <Skeleton isFull />;
};
